import React from 'react';
import SEO from '../components/SEO';
import './LegalPages.css';

const CookiesPolicy = () => {
  return (
    <>
      <SEO
        title="Cookies Policy | Tech Update"
        description="Learn about how Tech Update uses cookies on our website. Understand cookie types, purposes, and how to manage your cookie preferences."
        keywords="cookies policy, cookie usage, web cookies, cookie management, privacy cookies"
        url="https://www.gettechupdate.com/cookies-policy"
      />
      <div className="legal-page">
      <div className="legal-container">
        <h1>Cookies Policy</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. What Are Cookies?</h2>
          <p>
            Cookies are small text files that are placed on your device when you visit a website. They are widely 
            used to make websites work more efficiently and provide information to website owners.
          </p>
        </section>

        <section>
          <h2>2. How We Use Cookies</h2>
          <p>Tech Update uses cookies for the following purposes:</p>
          
          <h3>2.1 Essential Cookies</h3>
          <p>
            These cookies are necessary for the website to function properly. They enable core functionality such as 
            security, network management, and accessibility.
          </p>

          <h3>2.2 Performance Cookies</h3>
          <p>
            These cookies help us understand how visitors interact with our website by collecting and reporting information 
            anonymously. This helps us improve the way our website works.
          </p>

          <h3>2.3 Functionality Cookies</h3>
          <p>
            These cookies allow the website to remember choices you make (such as your language preference) and provide 
            enhanced, personalized features.
          </p>

          <h3>2.4 Targeting/Advertising Cookies</h3>
          <p>
            These cookies may be used to deliver relevant advertisements and track the effectiveness of our advertising 
            campaigns. They may also be used to limit the number of times you see an advertisement.
          </p>
        </section>

        <section>
          <h2>3. Types of Cookies We Use</h2>
          <table className="cookies-table">
            <thead>
              <tr>
                <th>Cookie Name</th>
                <th>Purpose</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>session_id</td>
                <td>Maintains user session</td>
                <td>Session</td>
              </tr>
              <tr>
                <td>preferences</td>
                <td>Stores user preferences</td>
                <td>1 year</td>
              </tr>
              <tr>
                <td>analytics</td>
                <td>Website analytics and performance</td>
                <td>2 years</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>4. Third-Party Cookies</h2>
          <p>
            We may also use third-party cookies from trusted partners for analytics and advertising purposes. These 
            third parties may use cookies to collect information about your online activities across different websites.
          </p>
          <p>Third-party services we may use include:</p>
          <ul>
            <li>Google Analytics - Website analytics</li>
            <li>Social Media Platforms - Social sharing features</li>
            <li>Advertising Networks - Targeted advertising</li>
          </ul>
        </section>

        <section>
          <h2>5. Managing Cookies</h2>
          <p>You have the right to accept or reject cookies. Most web browsers automatically accept cookies, but you 
          can usually modify your browser settings to decline cookies if you prefer.</p>
          
          <h3>Browser Settings</h3>
          <p>You can control cookies through your browser settings:</p>
          <ul>
            <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies and other site data</li>
            <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
            <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
            <li><strong>Edge:</strong> Settings → Privacy, search, and services → Cookies and site permissions</li>
          </ul>

          <p>
            <strong>Note:</strong> Disabling cookies may affect the functionality of our website and your user experience.
          </p>
        </section>

        <section>
          <h2>6. Cookie Consent</h2>
          <p>
            When you first visit our website, you may see a cookie consent banner. By continuing to use our website, 
            you consent to our use of cookies in accordance with this policy.
          </p>
        </section>

        <section>
          <h2>7. Updates to This Policy</h2>
          <p>
            We may update this Cookies Policy from time to time to reflect changes in our practices or for other 
            operational, legal, or regulatory reasons. Please review this page periodically for any updates.
          </p>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about our use of cookies, please contact us:
          </p>
          <p>
            <strong>Email:</strong> info@gettechupdate.com<br />
            <strong>Phone:</strong> +91 8269277543
          </p>
        </section>
      </div>
    </div>
    </>
  );
};

export default CookiesPolicy;

